import {
    HomeOutlined,
    OrderedListOutlined,
    KeyOutlined,
    FileProtectOutlined,
    PicCenterOutlined,
    DesktopOutlined,
    BarChartOutlined,
} from '@ant-design/icons';
import Layout from '../layouts'
// 将项目中的路由关系配置成数组
/**
 * path 匹配的路径，就是 Route 的 path
 * component 要渲染的组件
 * children 需要在当前页面渲染的子路由，也是个数组和外层路由结构基本一致
 */
const routes = [
    {
        path: "/",
        directLoad: true,
        component: Layout,
        redirect:'/home',
        name: '欢迎',
        children: [
            {
                path: "/home",
                name: 'Home',
                isCommon: true,
                icon: <HomeOutlined />,
                component: () => import('../pages/home'),
                children:[]
            },
            {
                path: "/licenseList",
                name: 'Licenses',
                isCommon: true,
                icon: <OrderedListOutlined />,
                component: () => import('../pages/licenseList'),
                children:[]
            },
            {
                path: "/licenseDetail",
                name: 'License Detail',
                isCommon: true,
                icon: <PicCenterOutlined />,
                component: () => import('../pages/licenseDetail'),
                children:[]
            },
            {
                path: "/licenseRequest",
                name: 'LicenseRequest',
                menuKey:'/home',
                hidden: true,
                component: () => import('../pages/licenseRequest'),
                children:[]
            },
            {
                path: "/apiKeys",
                name: 'API Keys',
                icon: <KeyOutlined />,
                component: () => import('../pages/apiKeys'),
                children:[]
            },
            {
                path: "/tokensList",
                name: 'Tokens',
                icon: <FileProtectOutlined />,
                component: () => import('../pages/tokensList'),
                children:[]
            },
            {
                path: "/hosts",
                name: 'Hosts',
                icon: <DesktopOutlined />,
                component: () => import('../pages/hardWare'),
                children:[]
            },
            {
                path: "/report",
                name: 'Report',
                icon: <BarChartOutlined />,
                component: () => import('../pages/report'),
                children:[]
            },
            {
                path: "/personalCenter",
                name: 'PersonalCenter',
                hidden: true,
                component: () => import('../pages/personalCenter'),
                children:[]
            },
            {
                path: "/help",
                name: 'Help',
                hidden: true,
                component: () => import('../pages/help'),
                children:[]
            }
        ]   
    },
    {
        path: "/login",
        component: () => import('../pages/login'),
        name: '登录'
    },
    {
        path: "/forgotPwd",
        component: () => import('../pages/forgotPwd'),
        name: '忘记密码'
    },
]


/**
 * @description: 全局路由拦截
 * @param {string} pathname 当前路由路径
 * @param {object} meta 当前路由自定义meta字段
 * @param {string} redirect 需要重定向的路径
 * @return {string} 需要跳转到其他页时，就返回一个该页的path路径，或返回resolve该路径的promise对象
 */
const onRouteBefore = ({pathname,meta,redirect,path}) => {

    // 未登录跳转到登录
    if(!['/login','/register','/forgotPwd'].includes(pathname) && !localStorage.getItem('userData')){
        document.title = '登录'
        sessionStorage.setItem('loginPath',window.location.pathname)
        return '/login'
    }
    if(['/apiKeys','/tokensList','/hosts','/report'].includes(pathname) &&  !sessionStorage.getItem('webLicenseId')){
        return'/licenseDetail'
    }

    // 动态修改页面title
    if (meta.title !== undefined) {
        document.title = meta.title
    }
    // 重定向到子路由
    if (redirect && pathname===path) {
        return redirect
    }
}
  
export {
    routes,
    onRouteBefore
}